import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { isEqual, ternary } from './javascript'

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)

const dayJs = (...args) => dayjs(...args)

const SAVE_FORMAT = 'DD/MM/YYYY'
const DISPLAY_FORMAT = 'YYYY/MM/DD'

const formatDate = (date, format = DISPLAY_FORMAT) =>
  ternary(date, dayJs(date, format), null)

const isInvalidDate = date => {
  if (!date) return true
  if (isEqual(date, 'Invalid Date')) return true
  if (dayjs.isDayjs(date)) return !date.isValid()
  return !dayjs(date).isValid()
}
const normalizeDate = dateStr => {
  const normalized = dayJs(
    dateStr,
    [
      'M-YYYY',
      'MM-YYYY',
      'MM/YYYY',
      'DD/MM/YYYY',
      'DD-MM-YYYY',
      'YYYY/MM/DD',
      'YYYY-MM-DD',
    ],
    true,
  ) // true = strict parsing
  return normalized.isValid() ? normalized : null
}

const convertDateToMillisecond = date => {
  return date ? dayJs(date, SAVE_FORMAT).valueOf() : null
}
const formatDateToDDMMYYYY = date => {
  return date ? dayJs(date, SAVE_FORMAT).format(SAVE_FORMAT) : null
}

export {
  dayJs,
  SAVE_FORMAT,
  DISPLAY_FORMAT,
  formatDate,
  isInvalidDate,
  normalizeDate,
  convertDateToMillisecond,
  formatDateToDDMMYYYY,
}
